import { useConfigContext } from "@/app";
import { CopyIconWithText } from "@/components/CopyIconWithText";
import { Icon, IconName } from "@/components/Icon";
import { Level } from "@/components/Level";
import { UserInfo as Data } from "@/types/Api/User/User/MyAccount/login";
import { Grid, Image, Space } from "antd-mobile";
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
type UserInfoAction = {
  icon: IconName;
  type: string;
  text: string;
};
type UserInfoProps = {
  user: Data;
};
const _actions: UserInfoAction[] = [{
  icon: "user-wallet",
  type: "user_bill",
  text: "个人账变"
}, {
  icon: "user-exchange",
  type: "user_transfer",
  text: "个人转账"
}];
export const UserInfo = ({
  user
}: UserInfoProps) => {
  const {
    getSourcePath
  } = useConfigContext();
  const navigate = useNavigate();
  const onAction = (type: string) => {
    navigate(`/${type}`);
  };
  const avatar = React.useMemo(() => {
    return getSourcePath(user.avatar);
  }, [user.avatar]);
  return <div className={styles.userInfo} data-sentry-component="UserInfo" data-sentry-source-file="index.tsx">
      <div className={styles.userInfoContent}>
        <Space align="center" data-sentry-element="Space" data-sentry-source-file="index.tsx">
          <div className={`${styles.userInfoAvatar} ${!user.avatar ? styles.defaultAvatar : ""}`} onClick={() => navigate("/user_nickname")}>
            {user.avatar ? <Image src={avatar} fit="cover" style={{
            borderRadius: "100%",
            height: '100%',
            width: '100%'
          }} /> : null}
            <div className={styles.userInfoAvatarAction}>
              <Icon name={"user-edit"} size={"16px"} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
            </div>
          </div>
          <div className={styles.userInfoText}>
            <div className={styles.userInfoName}>{user.nickname}</div>
            <Space align="center" className={styles.userInfoRank} data-sentry-element="Space" data-sentry-source-file="index.tsx">
              信用等级{" "}
              <Level level={user.creditLevel} onClick={() => navigate("/level")} data-sentry-element="Level" data-sentry-source-file="index.tsx" />
            </Space>
          </div>
        </Space>
      </div>
      <Grid columns={2} className={styles.userInfoActions} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
        {_actions.map((action: UserInfoAction) => <Grid.Item className={styles.userInfoAction} key={action.type} onClick={() => onAction(action.type)}>
            <div className={styles.userInfoActionIcon}>
              <Icon name={action.icon} size="0.30rem" />
            </div>
            <div className={styles.userInfoActionIconText}>{action.text}</div>
          </Grid.Item>)}
      </Grid>
      <div className={styles.userInfoCode}>
        <CopyIconWithText className={styles.userInfoAddr} text={user.walletAddress} encryption={true} isWalletAddress={true} data-sentry-element="CopyIconWithText" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};